import { IIdTextId, INameIdObj } from '../fi-shared-interfaces';
import {
    Checkpoint2MeasureUnitType,
    Checkpoint2StatusType,
    CheckpointActionConditionType,
    CheckpointActionLocationType,
    CheckpointActionRecipientType,
    CheckpointActionTimePeriodType,
    CheckpointConditionTargetType,
    CheckpointConditionType,
    CheckpointRangeType,
    CheckpointScoringType,
} from './checklist-enum';

/*export const ChecklistStatusColors = {
    [ChecklistStatus.NotFilledOut]: '#b8b8b8',
    [ChecklistStatus.Ok]: '#5aaf4b',
    [ChecklistStatus.Deviation]: '#cbe6c8',
    [ChecklistStatus.Failed]: '#f44336',
    [ChecklistStatus.OkCheckpoints]: '#FFECB3',
    [ChecklistStatus.DeviationCheckpoints]: '#FFC107'
}*/
/*export const ChecklistStatusTextIds = {
    [ChecklistStatus.NotFilledOut]: 'checklist.status_not_filled_out',
    [ChecklistStatus.Ok]: 'checklist.status_ok',
    [ChecklistStatus.Deviation]: 'checklist.status_deviation',
    [ChecklistStatus.Failed]: 'checklist.status_failed'
};*/

/*export const ChecklistStatusFullTextIds = {
    [ChecklistStatus.NotFilledOut]: 'checklist.status_not_filled_out',
    [ChecklistStatus.Ok]: 'checklist.status_ok_full',
    [ChecklistStatus.Deviation]: 'checklist.status_deviation_full',
    [ChecklistStatus.Failed]: 'checklist.status_failed_full'
};*/

/*export const ChecklistStatusMobileTextIds = {
    [ChecklistStatus.Ok]: 'checklist.status_ok_mobile',
    [ChecklistStatus.Deviation]: 'checklist.status_deviation_mobile'
};*/

/*export const ChecklistStatusPointsPerUnitTextIds = {
    [ChecklistStatus.NotFilledOut]: 'checklist.points_per_unit.status_not_filled_out',
    [ChecklistStatus.Ok]: 'checklist_reports.ok_checkpoint',
    [ChecklistStatus.Deviation]: 'checklist.points_per_unit.status_deviation',
    [ChecklistStatus.Failed]: 'checklist.points_per_unit.status_failed',
    [ChecklistStatus.OkCheckpoints]: 'checklist.ok_checkpoints',
    [ChecklistStatus.DeviationCheckpoints]: 'checklist.checkpoint_deviations_per_unit'
};*/

export const CheckpointRangeTypesOptions: INameIdObj[] = [
    {
        Id: CheckpointRangeType.Between,
        Name: 'checklist.checkpoint_measurement_type_between',
    },
    {
        Id: CheckpointRangeType.Greater,
        Name: 'checklist.checkpoint_measurement_type_greater_and_equal',
    },
    {
        Id: CheckpointRangeType.Less,
        Name: 'checklist.checkpoint_measurement_type_less_and_equal',
    },
];

export const CheckpointRangeStatusOptions: INameIdObj[] = [
    {
        Id: Checkpoint2StatusType.Ok,
        Name: 'ok',
    },
    {
        Id: Checkpoint2StatusType.NotOk,
        Name: 'notOk',
    },
    {
        Id: Checkpoint2StatusType.NotFilledOut,
        Name: 'form.condition_is_not_answered',
    },
];

export const ConditionTargetTypeOptions: INameIdObj[] = [
    {
        Id: CheckpointConditionTargetType.Attachment,
        Name: 'common.attachment',
    },
    {
        Id: CheckpointConditionTargetType.Comment,
        Name: 'common.comment',
    },
    {
        Id: CheckpointConditionTargetType.QRCode,
        Name: 'qr_common.qr_code',
    },
];

export const CheckpointStatusConditionTypeOptions: INameIdObj[] = [
    {
        Id: CheckpointConditionType.Always,
        Name: 'common.always',
    },
    {
        Id: CheckpointConditionType.IsOk,
        Name: 'ok',
    },
    {
        Id: CheckpointConditionType.IsNotOk,
        Name: 'notOk',
    },
];

export const CheckpointMeasurementConditionTypeDefaultOptions: INameIdObj[] = [
    {
        Id: CheckpointConditionType.Always,
        Name: 'common.always',
    },
    {
        Id: CheckpointConditionType.IsOk,
        Name: 'ok',
    },
    {
        Id: CheckpointConditionType.IsNotOk,
        Name: 'notOk',
    },
];

export const CheckpointActionConditionTypeOptions: INameIdObj[] = [
    {
        Id: CheckpointActionConditionType.Answered,
        Name: 'checklist.checkpoint_action_condition_answered',
    },
    {
        Id: CheckpointActionConditionType.Ok,
        Name: 'checklist.checkpoint_action_condition_type_ok',
    },
    {
        Id: CheckpointActionConditionType.NotOk,
        Name: 'checklist.checkpoint_action_condition_type_deviation',
    },
    {
        Id: CheckpointActionConditionType.NotFilledOut,
        Name: 'checklist.checkpoint_action_condition_type_skipped',
    },
];

export const CheckpointActionAlertRecipientTypeOptions: INameIdObj[] = [
    {
        Id: CheckpointActionRecipientType.RolesLocal,
        Name: 'checklist.checkpoint_action_recipient_local_roles',
    },
    {
        Id: CheckpointActionRecipientType.Roles,
        Name: 'checklist.checkpoint_action_recipient_roles',
    },
    {
        Id: CheckpointActionRecipientType.Users,
        Name: 'checklist.checkpoint_action_recipient_staff_members',
    },
    {
        Id: CheckpointActionRecipientType.EmailAddress,
        Name: 'checklist.checkpoint_action_recipient_email_address',
    },
    {
        Id: CheckpointActionRecipientType.SMS,
        Name: 'checklist.checkpoint_action_recipient_sms',
    },
];

export const CheckpointActionAlertLocationTypeOptions: INameIdObj[] = [
    {
        Id: CheckpointActionLocationType.OnlyCurrent,
        Name: 'checklist.checkpoint_action_location_only_current',
    },
    {
        Id: CheckpointActionLocationType.AnyUserBelongsTo,
        Name: 'checklist.checkpoint_action_location_any_user_belongs_to',
    },
];

export const FiCheckpointActionTimePeriodTypeOptions: IIdTextId[] = [
    {
        id: CheckpointActionTimePeriodType.Days,
        textId: 'common.days',
    },
    {
        id: CheckpointActionTimePeriodType.Weeks,
        textId: 'common.weeks',
    },
    {
        id: CheckpointActionTimePeriodType.Months,
        textId: 'common.months',
    },
];

export const CheckpointActionRecipientHighlightedTypes: INameIdObj[] = [
    {
        Id: CheckpointActionRecipientType.RolesLocal,
        Name: 'checklist.checkpoint_action_recipient_roles_highlighted',
    },
    {
        Id: CheckpointActionRecipientType.Roles,
        Name: 'checklist.checkpoint_action_recipient_roles_highlighted',
    },
    {
        Id: CheckpointActionRecipientType.Users,
        Name: 'checklist.checkpoint_action_recipient_staff_members_highlighted',
    },
    {
        Id: CheckpointActionRecipientType.EmailAddress,
        Name: 'checklist.checkpoint_action_recipient_email_address_highlighted',
    },
    {
        Id: CheckpointActionRecipientType.SMS,
        Name: 'checklist.checkpoint_action_recipient_sms_highlighted',
    },
];

export interface ICheckpointMeasureUnitData {
    id: Checkpoint2MeasureUnitType;
    textId: string;
    iconClass: string;
    shortText?: string;
    shortTextId?: string;
}

export const Checkpoint2MeasureUnitTypes: ICheckpointMeasureUnitData[] = [
    {
        id: Checkpoint2MeasureUnitType.Fahrenheit,
        textId: 'common.fahrenheit',
        iconClass: 'fa-regular fa-temperature-high',
        shortText: '°F',
    },
    {
        id: Checkpoint2MeasureUnitType.Celsius,
        textId: 'common.celsius',
        iconClass: 'fa-regular fa-temperature-high',
        shortText: '°C',
    },
    {
        id: Checkpoint2MeasureUnitType.Ph,
        textId: 'common.ph',
        iconClass: 'fa-regular fa-temperature-high',
        shortText: 'pH',
    },
    {
        id: Checkpoint2MeasureUnitType.Kilogram,
        textId: 'common.kilogram',
        iconClass: 'fa-regular fa-weight-hanging',
        shortText: 'kg',
    },
    {
        id: Checkpoint2MeasureUnitType.Pounds,
        textId: 'common.pounds',
        iconClass: 'fa-regular fa-weight-hanging',
        shortText: 'lbs',
    },
    {
        id: Checkpoint2MeasureUnitType.Hours,
        textId: 'common.hours',
        iconClass: 'fa-regular fa-clock',
        shortText: 'h',
    },
    {
        id: Checkpoint2MeasureUnitType.Minutes,
        textId: 'common.minutes',
        iconClass: 'fa-regular fa-clock',
        shortText: 'min',
    },
    {
        id: Checkpoint2MeasureUnitType.Percent,
        textId: 'common.percent',
        iconClass: 'fa-regular fa-percent',
        shortText: '%',
    },
    {
        id: Checkpoint2MeasureUnitType.Pieces,
        textId: 'common.pieces',
        iconClass: 'fa-regular fa-puzzle-piece',
        shortTextId: 'common.pieces_short',
    },
    {
        id: Checkpoint2MeasureUnitType.Others,
        textId: 'common.others',
        iconClass: 'fa-regular fa-scale-unbalanced-flip',
        shortText: undefined,
    },
];

export interface ICheckpointScoringData {
    id: CheckpointScoringType;
    textId: string;
    defaultOkPts: number;
}

export const CheckpointScorings: ICheckpointScoringData[] = [
    {
        id: CheckpointScoringType.Critical,
        textId: 'common.critical',
        defaultOkPts: 30,
    },
    {
        id: CheckpointScoringType.Major,
        textId: 'common.major',
        defaultOkPts: 10,
    },
    {
        id: CheckpointScoringType.Minor,
        textId: 'common.minor',
        defaultOkPts: 3,
    },
];
